import React from "react";
import { graphql } from "gatsby";
import SEO from "../components/seo";
import Copy from "../components/sections/Copy";
import EmployeeCard from "../components/modules/EmployeeCard";
import FullWidthImage from "../components/sections/FullWidthImage";
import Hero from "../components/sections/Hero";
import Slideshow from "../components/sections/Slideshow";
import LeftImageText from "../components/sections/LeftImageText";
import RightImageText from "../components/sections/RightImageText";
import ReviewsAggregate from "../components/sections/Reviews";
import KeyBenefitsSection from "../components/sections/KeyBenefits";
import SlideWithSchematic from "../components/sections/SlideWithSchematic";
import BlockifiedModel from "../components/sections/BlockifiedModel";
import StructuredHomepage from "../components/structured-data/StructuredHomepage";
import AlteredComponent from "../components/elements/AlteredComponent";
import Impact from "../components/impact/universalTracking";
import Ugc from "../components/sections/UGC";
import { useDataLayer } from "../hooks/dataLayer";

const IndexPage = ({ data }) => {
  const { pageContent } = data.datoCmsHomePage;
  const trimmedPageContent = pageContent.filter((page) => page.internal);

  const getComponentFromBlockType = (blockType) => {
    const alteredCta =
      (C) =>
      ({ ...args }) => {
        return (
          <AlteredComponent css="altered-cta">
            <C {...args} />
          </AlteredComponent>
        );
      };

    const alteredCopy =
      (C) =>
      ({ ...args }) => {
        return (
          <AlteredComponent css="altered-copy">
            <C {...args} />
          </AlteredComponent>
        );
      };

    const components = {
      Copy: alteredCopy(Copy),
      FullWidthImage,
      Hero: alteredCta(Hero),
      LeftImageText,
      RightImageText,
      EmployeeCard,
      ReviewsAggregate,
      KeyBenefitsSection,
      BlockifiedModel,
      SlideWithSchematic,
      Slideshow,
    };
    const componentToRender = components[blockType.split("DatoCms")[1]];
    return componentToRender;
  };

  const renderHomePageContent = (pageContent, customClass) => {
    return (
      <div>
        {pageContent.map((item, index) => {
          const blockType = item.internal.type;
          const Component = getComponentFromBlockType(blockType);
          const key = index;

          if (!Component) {
            return <></>;
          }

          return (
            <Component
              key={key}
              customClass={customClass}
              data={item}
              field={blockType}
            />
          );
        })}
      </div>
    );
  };

  useDataLayer({ event: "HomeView", pageType: "home" });

  return (
    <>
      <StructuredHomepage />
      <SEO
        title={data.datoCmsHomePage.title}
        description={data.datoCmsHomePage.metaDescription}
      />
      <Impact />
      <div className="Homepage">
        {renderHomePageContent(trimmedPageContent, "")}
      </div>
      <Ugc />
    </>
  );
};

export default IndexPage;

export const homePageQuery = graphql`
  query homePage($locale: String!) {
    datoCmsHomePage(locale: { eq: $locale }) {
      locale
      title
      metaDescription
      pageContent {
        ...HeroComponent
        ...KeyBenefitsComponent
        ...CopyComponent
        ...LeftImageTextComponent
        ...RightImageTextComponent
        ...BlockifiedModelComponent
        ...ReviewsAggregate
        ...SlideWithSchematic
        ...HubspotFormComponent
        ...SlideShowComponent
      }
    }
  }
`;
